import {get, post} from "./action.service";
import shadows from "@material-ui/core/styles/shadows";
import axios, { AxiosRequestConfig } from 'axios';
import { Auth } from "aws-amplify";
import { defaultConfig } from './action.service';
import _ from "lodash";
import { getRotation, putRotation } from "./rotation.service";
import { RelayTypes, RelayPathIdTypes } from "../enums/relayTypes";

export const getState = async(shadowName: string) => {

    const user = await Auth.currentAuthenticatedUser();
    return axios.get('/GetDeviceShadow', _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    }, {params: {
        shadowName: shadowName
    }}))
    // return get('/getNamedDeviceShadow', {
    //     shadowName: shadowName
    // });
}

export const postState = async(data: any, shadowName: string) => {
    const user = await Auth.currentAuthenticatedUser();
    return axios.post('/UpdateDeviceShadowName2',{
        shadowName,
        data: data
    }, _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    }))
    //return post('/UpdateDeviceShadowName2', data, shadowName);
}

export const getCommunicationStatus = async() => {
    const user = await Auth.currentAuthenticatedUser();
    return axios.get('/getCommunicationStatus', _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    }))
    // return get('/getCommunicationStatus');
}

export const postCommunicationState = async(data: any) => {
    const user = await Auth.currentAuthenticatedUser();
    return axios.post('/updateCommunicationStatus',{
        data: data
    }, _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    }))
    // return post('/updateCommunicationStatus', data);
}

export const getNames = async() => {
    return getState('SettingsNames');
}

export const updateNames = (data: any) => {
    return postState({
        SettingsNames: data
    }, 'SettingsNames');
}

export const getIrdaTrigger = async() => {
    const user = await Auth.currentAuthenticatedUser();
    return axios.get('/getIrdaTrigger', _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    },))
    // return get('/getIrdaTrigger');
}

export const updateIrdaTrigger = async(data: any) => {
    const user = await Auth.currentAuthenticatedUser();
    return axios.post('/updateIrdaTrigger',{
        data: data
    }, _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    }))
    // return post('/updateiradtrigger', data);
}

export const updateRotationWithActive = async(data: any) => {
    const user = await Auth.currentAuthenticatedUser();
    return axios.post('/updateRotationWithActive',{
        data: data
    }, _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    }))
    // return post('/updateRotationWithActive', data, 'RedundacySettingsId')
}

export const updateManulSettings = async(data: object) => {
    const user = await Auth.currentAuthenticatedUser();
    const manualSettings = _.get(data, 'ManualSettings');
    const keys = Object.keys(manualSettings)
    const filteredKeys = keys.filter((item) => item.includes('Relay') || item.includes('Irda'));
    if (filteredKeys.length > 0) {
        const firstItem = _.first(filteredKeys)
        if (firstItem) {
            const relayType = firstItem?.includes('Relay') ? RelayTypes.RELAY : RelayTypes.IRDA
            const key = relayType === RelayTypes.RELAY ? 'relay' + firstItem[5] : 'irda' + firstItem[4]
            const isActive = _.get(manualSettings, firstItem);
            return getRotation().then(
                (res: any) => {
                    switch (relayType) {
                        case RelayTypes.RELAY: {
                            const idOfDevice = parseInt(key.replace(RelayPathIdTypes.RELAY, ''), 10);
                            const airConditioners = res.airConditioners || [];
                            if (res.redundancy && isActive && airConditioners.some((ac: number) => ac === (idOfDevice - 1))) {
                                const rotationToSend = _.assign({}, res, {
                                    redundancy: false
                                })
                                console.log('rotation to send')
                                return putRotation(rotationToSend).then(() => {
                                    return axios.post('/updateManualSettings',{
                                        data: data
                                    }, _.assign(defaultConfig, {
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'username': user.username
                                        }
                                    }))
                                })
                                // return Promise.all([putRotation(rotationToSend), postState(createAbstractRelayToSend(data, mode, id, convertedHours, isActive, RelayPathIdTypes.RELAY, RelayTypes.RELAY), getRelayShadowName(id))])
                            } else {
                                console.log('rotation not to send')
                                return axios.post('/updateManualSettings',{
                                    data: data
                                }, _.assign(defaultConfig, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'username': user.username
                                    }
                                }))
                                // return Promise.all([postState(createAbstractRelayToSend(data, mode, id, convertedHours, isActive, RelayPathIdTypes.RELAY, RelayTypes.RELAY), getRelayShadowName(id))])
                            }
                            break;
                        }
                        case RelayTypes.IRDA: {
                            const idOfDevice = parseInt(key.replace('irda', ''), 10);
                            const airConditioners = res.airConditioners || [];
                            if (res.redundancy && isActive && airConditioners.some((ac: number) => ac === (idOfDevice + 4))) {
                                const rotationToSend = _.assign({}, res, {
                                    redundancy: false
                                })
                                return putRotation(rotationToSend).then(() => {
                                    return axios.post('/updateManualSettings',{
                                        data: data
                                    }, _.assign(defaultConfig, {
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'username': user.username
                                        }
                                    }))
                                })
                            } else {
                                return axios.post('/updateManualSettings',{
                                    data: data
                                }, _.assign(defaultConfig, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'username': user.username
                                    }
                                }))
                                // return Promise.all([postState(createAbstractRelayToSend(data, mode, id, convertedHours, isActive, RelayPathIdTypes.IRDA, RelayTypes.IRDA), getRelayShadowName(id))])
                            }
                            break;
                        }
                    }
                }
            )
        }
        
    }
    return axios.post('/updateManualSettings',{
        data: data
    }, _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    }))
    // return post('/updateManualSettings', data, )
}

export const getManualSettings = async() => {
    const user = await Auth.currentAuthenticatedUser();
    return axios.get('/getManualSettings', _.assign(defaultConfig, {
        headers: {
            'Content-Type': 'application/json',
            'username': user.username
        }
    }))
    // return get('/getManualSettings');
}